import { lazy } from 'react';

const GidNoSSO = lazy(() => import('@pages/GidNoSSO'));
const Election = lazy(() => import('@pages/Election'));
const Ssga = lazy(() => import('@pages/Ssga'));
const MetlifeIiaQuoting = lazy(() => import('@pages/MetlifeIiaQuoting'));
const MetlifeIiaEducation = lazy(() => import('@pages/MetlifeIiaEducation'));
const MetlifeIiaElection = lazy(() => import('@pages/MetlifeIiaElection'));
const SsgaNoSSO = lazy(() => import('@pages/SsgaNoSSO'));
const Jpm = lazy(() => import('@pages/Jpm'));
const JpmNoSSO = lazy(() => import('@pages/JpmNoSSO'));
const Demo = lazy(() => import('@pages/Demo'));
const Trlit = lazy(() => import('@pages/Trlit'));
const RicAlightQuoting = lazy(() => import('@pages/Alight'));
const RicAlightEducation = lazy(() => import('@pages/Alight'));
const RicAlightElection = lazy(() => import('@pages/Alight'));

export const SHUTTLE_REGISTRY = {
  Election,
  GidNoSSO,
  Ssga,
  SsgaNoSSO,
  MetlifeIiaQuoting,
  MetlifeIiaEducation,
  MetlifeIiaElection,
  Jpm,
  JpmNoSSO,
  Demo,
  Trlit,
  RicAlightQuoting,
  RicAlightEducation,
  RicAlightElection,
};
